module.exports = __webpack_public_path__ + "img/truss_designs_buttons_small.334c318f.jpg";